import React from "react";
import { Link } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import People from "@material-ui/icons/People";
import Assessment from "@material-ui/icons/Assessment";
import VideoLabel from "@material-ui/icons/VideoLabel";
import GroupWork from "@material-ui/icons/GroupWork";
import Extension from "@material-ui/icons/Extension";
import WatchLater from "@material-ui/icons/WatchLater";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import Button from "components/CustomButtons/Button.jsx";

import featuresStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.jsx";

function SectionLocalGovernmentRydeStrategyFeatures({ ...props }) {
  const { classes, ...rest } = props;
  return (
    <div className="cd-section" {...rest}>
      <div className={classes.container}>
        {/* Feature 1 START */}
        <div className={classes.features1}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={8}
              md={8}
              className={`${classes.mlAuto} ${classes.mrAuto}`}
            >
              <h2 className={classes.title}>Case Study: NSW Training Awards</h2>
              <h5 className={classes.description}>
                FRANK has worked with NSW Department of Education & Training
                since 2014. In 2019, we embarked on a partnership to develop
                online learning resources for Regional and State Finalists and
                Ambassadors who were being selected to represent NSW for the
                national Australian Training Awards. Over 75 participants were
                able to access this online learning including participants
                located regionally.
              </h5>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={4} md={4}>
              <InfoArea
                vertical
                icon={VideoLabel}
                title="Online Video Resources"
                description="FRANK designed and delivered 2 bite-sized learning courses: Introduction to Communication Skills & Presentation Skills. Participants can access these courses 24/7 using their own login and passwords and able to develop their self-directed learning skills."
                iconColor="info"
              />
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <InfoArea
                vertical
                icon={Assessment}
                title="Quarterly Progress Reports"
                description="FRANK produces quarterly progress reports demonstrating how learners are making their way through the course."
                iconColor="info"
              />
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <InfoArea
                vertical
                icon={People}
                title="Compliments F-2-F Training"
                description="FRANK has designed these 2 courses to be used as 'stand-alone' courses i.e. there are activities and resources provided within the video library itself for self-learning. However, if you'd like to deliver face-to-face training, these videos can compliment this as well."
                iconColor="info"
              />
            </GridItem>
          </GridContainer>
        </div>
        <div className={classes.features3}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={8}
              md={8}
              className={`${classes.mlAuto} ${classes.mrAuto} ${
                classes.textCenter
              }`}
            >
              <h2 className={classes.title}>Online Module Topics & Info</h2>
            </GridItem>
            <GridContainer>
              <GridItem xs={12} sm={4} md={4}>
                <InfoArea
                  className={classes.infoArea}
                  icon={Extension}
                  title="Communication Skills"
                  description={
                    <span>
                      FRANK courses enable participants to master foundational
                      communication precepts as well as to develop skills such
                      as active listening and story telling. Learners are able
                      to self assess their own communication style.
                      <br />
                      <Link
                        to="/product-page/communication-strategies-page"
                        className={classes.block}
                      >
                        <Button
                          color="danger"
                          size="sm"
                          // href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
                          // target="_blank"
                          // rel="noopener noreferrer"
                        >
                          Course Information
                        </Button>
                      </Link>
                    </span>
                  }
                  iconColor="info"
                />
              </GridItem>
              <GridItem xs={12} sm={4} md={4}>
                <InfoArea
                  className={classes.infoArea}
                  icon={GroupWork}
                  title="Presentation Skills"
                  description={
                    <span>
                      FRANK customised a presentation skills course to prepare
                      participants from the VET and vocational industries to be
                      Ambassadors and represent themselves at regional, state
                      and national level. Participants learn key strategies of
                      speechcraft as well as how to respond confidently during
                      interviews.
                      <Link
                        to="/product-page/presentation-skills-page"
                        className={classes.block}
                      >
                        <Button color="danger" size="sm">
                          Course Information
                        </Button>
                      </Link>
                    </span>
                  }
                  iconColor="info"
                />
              </GridItem>
              <GridItem xs={12} sm={4} md={4}>
                <InfoArea
                  className={classes.infoArea}
                  icon={WatchLater}
                  title="1 Annual Licence Fee"
                  description={
                    <span>
                      For our online learning programs, we provide you with an
                      unlimited access learning licence valid for 1 year. Each
                      licence can be used by upto 300 learners. Learners can
                      learn on their own time and at their own pace.
                      <br />
                      <Link to="/contact-us" className={classes.block}>
                        <Button
                          color="danger"
                          size="sm"
                          // href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
                          // target="_blank"
                          // rel="noopener noreferrer"
                        >
                          Contact Us
                        </Button>
                      </Link>
                    </span>
                  }
                  iconColor="info"
                />
              </GridItem>
            </GridContainer>
          </GridContainer>
        </div>
      </div>
    </div>
  );
}

export default withStyles(featuresStyle)(
  SectionLocalGovernmentRydeStrategyFeatures
);
